/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {AuthorityDTO} from './AuthorityDTO';

/**
 * The UserDTO model module.
 * @module model/UserDTO
 * @version v0
 */
export class UserDTO {
  /**
   * Constructs a new <code>UserDTO</code>.
   * @alias module:model/UserDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>UserDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserDTO} obj Optional instance to populate.
   * @return {module:model/UserDTO} The populated <code>UserDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new UserDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('authorities'))
        obj.authorities = ApiClient.convertToType(data['authorities'], [AuthorityDTO]);
      if (data.hasOwnProperty('displayName'))
        obj.displayName = ApiClient.convertToType(data['displayName'], 'String');
      if (data.hasOwnProperty('company'))
        obj.company = ApiClient.convertToType(data['company'], 'String');
      if (data.hasOwnProperty('office'))
        obj.office = ApiClient.convertToType(data['office'], 'String');
      if (data.hasOwnProperty('updatedAt'))
        obj.updatedAt = ApiClient.convertToType(data['updatedAt'], 'Date');
      if (data.hasOwnProperty('email'))
        obj.email = ApiClient.convertToType(data['email'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
UserDTO.prototype.id = undefined;

/**
 * @member {Array.<module:model/AuthorityDTO>} authorities
 */
UserDTO.prototype.authorities = undefined;

/**
 * @member {String} displayName
 */
UserDTO.prototype.displayName = undefined;

/**
 * @member {String} company
 */
UserDTO.prototype.company = undefined;

/**
 * @member {String} office
 */
UserDTO.prototype.office = undefined;

/**
 * @member {Date} updatedAt
 */
UserDTO.prototype.updatedAt = undefined;

/**
 * @member {String} email
 */
UserDTO.prototype.email = undefined;

